/* eslint-disable react/no-array-index-key */
import React, {
  lazy,
  Suspense,
  Fragment
} from 'react';
import {
  Switch,
  Redirect,
  Route
} from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import MainLayout from 'src/layouts/MainLayout';
import LoadingScreen from 'src/components/LoadingScreen';
import AuthGuard from 'src/components/AuthGuard';
import GuestGuard from 'src/components/GuestGuard';

const routesConfig = [
  {
    exact: true,
    path: '/',
    component: () => <Redirect to="/app/dashboard" />
  },
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('src/views/Pages/Error404View'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/login',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    path: '/login-unprotected',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/verification/:id/:token',
    component: lazy(() => import('src/views/auth/VerificationView'))
  },
  {
    path: '/app',
    guard: AuthGuard,
    layout: DashboardLayout,
    routes: [
      {
        exact: true,
        path: '/app',
        component: () => <Redirect to="/app/dashboard" />
      },
      {
        exact: true,
        path: '/app/dashboard',
        component: lazy(() => import('src/views/Pages/Dashboard'))
      },
      {
        exact: true,
        path: '/app/configuration/details',
        component: lazy(() => import('src/views/Pages/Configuration/Details'))
      },
      {
        exact: true,
        path: '/app/configuration/sites',
        component: lazy(() => import('src/views/Pages/Configuration/Sites'))
      },
      {
        exact: true,
        path: '/app/configuration/clubs',
        component: lazy(() => import('src/views/Pages/Configuration/Clubs'))
      },
      {
        exact: true,
        path: '/app/configuration/rewards',
        component: lazy(() => import('src/views/Pages/Configuration/Rewards'))
      },
      {
        exact: true,
        path: '/app/configuration/pointAllocation',
        component: lazy(() => import('src/views/Pages/Configuration/PointAllocation'))
      },
      {
        exact: true,
        path: '/app/reports',
        component: lazy(() => import('src/views/Pages/Reports'))
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  },
  {
    path: '/browse',
    guard: AuthGuard,
    layout: DashboardLayout,
    routes: [
      {
        exact: true,
        path: '/browse',
        component: () => <Redirect to="/app/dashboard" />
      },
    ]
  },
  {
    path: '*',
    layout: MainLayout,
    routes: [
      {
        exact: true,
        path: '/home',
        component: () => <Redirect to="/app/dashboard" />
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  }
];

const renderRoutes = (routes) => (routes ? (
  <Suspense fallback={<LoadingScreen />}>
    <Switch>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Component = route.component;

        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            render={(props) => (
              <Guard>
                <Layout>
                  {route.routes
                    ? renderRoutes(route.routes)
                    : <Component {...props} />}
                </Layout>
              </Guard>
            )}
          />
        );
      })}
    </Switch>
  </Suspense>
) : null);

function Routes() {
  return renderRoutes(routesConfig);
}

export default Routes;
